export default __webpack_public_path__ + "static/media/shu.482a816a.svg";